import { getCurrentLanguage } from '../LanguageHelper';

function getEnv(url) {
  let env;
  if (url.includes('acc.dkv.be')) {
    env = 'acc';
  } else if (url.includes('dkv-mc.be')) {
    env = 'prod';
  } else if (url.includes('localhost')) {
    env = 'dev';
  } else {
    env = 'test';
  }

  return env;
}

function prepPageName(text) {
  // Remove language part
  text = text.replace(/\/[a-z]{2}\//, '/');

  // Remove leading slash
  text = text.replace(/^\/|\/$/g, '');

  // Remove digits
  text = text.replace(/\d+/g, '#');

  return text;
}

export function pushTrackEventPageName(pageName) {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (!window.appEventData) {
    window.appEventData = [];
  }
  window.appEventData.push({
    event: 'PageLoaded',
    page: {
      attributes: {
        displayedBrand: 'DKV',
        language: getCurrentLanguage(),
        viewPort: isMobile ? 'mobile' : 'desktop'
      },
      pageInfo: {
        sysEnv: getEnv(window.location.href),
        issueDate: 'medicard|' + process.env.REACT_APP_BUILD_DATE,
        pageName: pageName
      }
    },
    miscellaneous: {
      agency: {
        oenrNumber: window.provider_id
      }
    }
  });
}

export function pushTrackEvent() {
  pushTrackEventPageName(prepPageName(window.location.pathname));
}
